import capitalize from 'lodash/capitalize';

const febLeapYearDays = 29;
const monthsDays = [
  31, // jan
  28, // feb
  31, // mar
  30, // apr
  31, // may
  30, // jun
  31, // jul
  31, // aug
  30, // sep
  31, // oct
  30, // nov
  31, // dec
];

export const monthsLabels = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];

export const getMonthLabel = monthNumber =>
  capitalize(monthsLabels[Math.max(1, Math.min(monthNumber, 12)) - 1]);

export const isLeapYear = year =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

export const getMonthDayYear = date => {
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return { month, day, year };
};

export const getISODate = ({ month, day, year }) => {
  const timestamp =
    Date.parse(`${month} ${day} ${year}`) ||
    Date.parse(`${month}/${day}/${year}`);

  return new Date(timestamp);
};

export const isWeekend = (date, countryWeekends) => {
  const isoDate = getISODate(date);
  const weekDay = isoDate.getDay();

  return countryWeekends.includes(weekDay.toString());
};

export const getDaysForMonth = (month, year) => {
  const monthIndex = month - 1;
  const isFebruary = monthIndex === 1;

  return isFebruary && isLeapYear(year)
    ? febLeapYearDays
    : monthsDays[monthIndex];
};

export const createDayListByWeeks = (date, weeks) => {
  const { month, day, year } = getMonthDayYear(date);
  const dayList = [];
  let totalDays = weeks * 7;
  let currentDay = day;
  let currentMonth = month;
  let currentYear = year;

  while (totalDays > 0) {
    dayList.push({
      day: currentDay,
      month: currentMonth,
      year: currentYear,
    });

    currentDay += 1;

    if (currentDay > getDaysForMonth(currentMonth, currentYear)) {
      currentDay = 1;
      currentMonth += 1;
    }

    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear += 1;
    }

    totalDays -= 1;
  }

  return dayList;
};
